// import * as ElasticEmail from '@elasticemail/elasticemail-client';
 

// export default function sendEmail (data) {
//     let defaultClient = ElasticEmail.ApiClient.instance;
     
//     let apikey = defaultClient.authentications['69E32B9CF74193F7A4AA6C2ED7128C3A150C837988996FCE694C292B197C90D335B03C0467D603CC7FA5A9AF65C20D0F'];
//     apikey.apiKey = "ED3D9162ED3681C20F97C6C1BCF20DB9F4F7"
     
//     let api = new ElasticEmail.EmailsApi()
     
//     let email = ElasticEmail.EmailMessageData.constructFromObject({
//       Recipients: [
//         new ElasticEmail.EmailRecipient("myblocks007@gmail.com ")
//       ],
//       Content: {
//         Body: [
//           ElasticEmail.BodyPart.constructFromObject({
//             ContentType: "HTML",
//             Content: `
//             <h2>Hello <br/> Quiz Form submitted<h2>
//             <ul>
//               <li>User Name: ${data.name}</li>
//               <li>Email: ${data.email}</li>
//             </ul>
//         `
//           })
//         ],
//         Subject: "Quiz Form submitted",
//         From: "mustafaalvi21@gmail.com "
//       }
//     });
     
//     var callback = function(error, data, response) {
//       if (error) {
//         console.error(error);
//       } else {
//         console.log('API called successfully.');
//       }
//     };
//     api.emailsPost(email, callback);

// }


export default function sendEmail(data) {
    // e.preventDefault();
    //   console.log(formVal);

    window.Email.send({
        Host: "smtp.elasticemail.com",
        Username: "myblocks007@gmail.com",//clien tMail
        Password: "ED3D9162ED3681C20F97C6C1BCF20DB9F4F7",
        Port: 2525,
        To: 'myblocks007@gmail.com',
        From: "myblocks007@gmail.com",//clien tMail
        Subject: "Quiz Form",
        Body: `
            <h2>New Quiz Form Submitted <h6>by <h6><h2>
            <ul>
              <li>User Name: ${data.name}</li>
              <li>Email: ${data.email}</li>
            </ul>
        `
    }).then(message => {
        // console.log(message)
        //   alert("Thanks to Submit Form")
        //   setdata({
        //     username:"",
        //     email:"",
        //     company:"",
        //     message:"",
        //   });
        //   handleClose()
    })
        .catch(err => {
            console.log(err);
        })
}


// api key: 69E32B9CF74193F7A4AA6C2ED7128C3A150C837988996FCE694C292B197C90D335B03C0467D603CC7FA5A9AF65C20D0F
// password: ED3D9162ED3681C20F97C6C1BCF20DB9F4F7
// server: smtp.elasticemail.com
// port: 2525